// src/services/recommendService.js
// Calls POST /api/recommend — AI skin-type to element recommender

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:4000';

/**
 * Send quiz answers to the backend and receive element recommendation.
 *
 * @param {Object} answers - { skinType, climate, concern, texture, fragrance }
 * @param {string|null} idToken - Firebase ID token (optional — works for guests)
 * @returns {Promise<{ primaryElement, secondaryElement, rationale, products }>}
 */
export const getRecommendation = async (answers, idToken = null) => {
  const headers = { 'Content-Type': 'application/json' };
  if (idToken) headers['Authorization'] = `Bearer ${idToken}`;

  const res = await fetch(`${API_URL}/api/recommend`, {
    method: 'POST',
    headers,
    body: JSON.stringify({ answers }),
  });

  if (!res.ok) {
    const err = await res.json().catch(() => ({}));
    throw new Error(err.error || `Recommendation failed: ${res.status}`);
  }

  return res.json();
};
